import React from 'react';
import { Navigate } from 'react-router-dom';
const PublicRoute = ({ children }) => {
  
  const isAuthenticated = localStorage.getItem('userId');

 
    if(isAuthenticated){
        return <Navigate to="/dashboard" replace />;
       
    }
       return children;
       
     
};

export default PublicRoute;